import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";

//import { PersonFill } from "react-bootstrap-icons";

import NavbarLogo from "./NavbarLogo.js";
import TeacherSigninModal from "./TeacherSigninModal.js";
import TeacherLoginModal from "./TeacherLoginModal.js";
import TeacherLogoutModal from "./TeacherLogoutModal.js";
import TeacherEditModal from "./TeacherEditModal.js";
import TeacherNewSimModal from "./TeacherNewSimModal.js";

export default function TeacherNavbar (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    // SIGNIN
    const [signin, setSignin] = useState(false);
    function showSignin () { setSignin(true); }
    function hideSignin () { setSignin(false); }
    function submitSignin (data) { gDispatch({ type: "teacherSignin", data }); setSignin(false); }

    // LOGIN
    const [login, setLogin] = useState(false);
    function showLogin () { setLogin(true); }
    function hideLogin () { setLogin(false); }
    function submitLogin (data) { gDispatch({ type: "teacherLogin", data }); setLogin(false); }
    
    // LOGOUT
    const [logout, setLogout] = useState(false);
    //function showLogout () { setLogout(true); }
    function hideLogout () { setLogout(false); }
    function submitLogout () { gDispatch({ type: "teacherLogout" }); setLogout(false); }

    // EDIT TEACHER
    const [editTeacher, setEditTeacher] = useState(false);
    function showEditTeacher () { setEditTeacher(true); }
    function hideEditTeacher () { setEditTeacher(false); }
    function submitEditTeacher (data) { gDispatch({ type: "upload", table: "teacher", id: gData.teacherID, data }); }

    // NEWSIM
    const [newSim, setNewSim] = useState(false);
    function showNewSim () { setNewSim(true); }
    function hideNewSim () { setNewSim(false); }

    function submitNewSim (data)
    {
	setNewSim(false);
	gDispatch({ type: "newSim", data });
    }

    return (
	<>
	    <Navbar expand="lg" className="bg-body-tertiary">
		<Container className="d-flex align-items-center">
		    <NavbarLogo/>
		    {(gData.teacherID !== null && gData.teacher[gData.teacherID] !== undefined) && (
			<Navbar.Text className="ms-3 fs-4">
			    {gData.teacher[gData.teacherID].firstName} {gData.teacher[gData.teacherID].lastName}
			</Navbar.Text>
		    )}
		    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
		    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
			<div className="d-flex gap-2">
			    {gData.teacherID === null && (
				<>
				    <Button variant="primary" size="md" onClick={showSignin}>Nouveau compte</Button>
				    <Button variant="primary" size="md" onClick={showLogin}>Connexion</Button>
				</>
			    )}
			    {gData.teacherID !== null && (
				<>
				    <Button variant="outline-secondary " size="md" onClick={showEditTeacher}>Paramètres du compte</Button>
				    <Button variant="primary" size="md" onClick={showNewSim}>Créer une nouvelle SIM</Button>
				    <Button variant="primary" size="md" onClick={submitLogout}>Déconnexion</Button>
				</>
			    )}
			</div>
		    </Navbar.Collapse>
		</Container>
	    </Navbar>
	    <TeacherSigninModal show={signin} hide={hideSignin} submit={submitSignin}/>
	    <TeacherLoginModal show={login} hide={hideLogin} submit={submitLogin}/>
	    <TeacherLogoutModal show={logout} hide={hideLogout} submit={submitLogout}/>
	    <TeacherEditModal show={editTeacher} hide={hideEditTeacher} submit={submitEditTeacher}/>
	    <TeacherNewSimModal show={newSim} hide={hideNewSim} submit={submitNewSim} />
	</>
    );
}
